/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class ContentFactory
 * @hideconstructor
 * @classdesc API class that is used to generate content specs and create them
 */
define([], () => {
	class ContentFactory {
		/**
		 * @public
		 * @deprecated
		 * @function ContentFactory#addModel
		 * @description Adds a new model to the boardModel
		 * @param {Object} content
		 * @param {String} content.type Content provider type to use.
		 * @param {Object} content.properties An object of property names & values to apply to the content.
		 * @param {TransactionToken} transactionToken
		 * @returns {Promise} Promise resolved with the added model id
		 */
		addModel() {}

		/**
		 * @public
		 * @deprecated
		 * @function ContentFactory#createContent
		 * @description Creates a content
		 * @param {Object} options Parameters to pass to the content class for instantiation
		 * @returns {Content} The content object
		 */
		createContent() {}

		/**
		 * @public
		 * @function ContentFactory#registerProvider
		 * @description Register a provider as a content provider.
		 * @param {Object} provider
		 */
		registerProvider() {}

	}

	return ContentFactory;
});
